import {
  Box,
  CircularProgress,
  FormControl,
  Stack,
  Typography,
} from "@mui/material";
import React, { useMemo } from "react";
import CFormErrors from "./CFormErrors";
import { useThemePalette } from "common/hooks/theme_palette";
import Select, { StylesConfig } from "react-select";
import { removeDuplicateObjects } from "services/modules/utils/Helper";

const CMultiSelect = ({
  options,
  changeAction,
  label,
  formik,
  name,
  index,
  value,
  ...rest
}) => {
  const { labelColor, oliveGreen } = useThemePalette();
  const errorsMsg = formik?.errors[name];
  const dedupedOptions = useMemo(
    () => removeDuplicateObjects(options, "id"),
    [options],
  );
  const handelOptions = useMemo(
    () =>
      dedupedOptions?.map((val) => ({
        label: val?.name,
        value: val?.id,
        color: val?.color,
      })),
    [dedupedOptions],
  );
  const formikValue = formik?.values[name];
  const valueData = useMemo(
    () =>
      typeof formikValue != "object"
        ? handelOptions?.find((val) => val?.value == formikValue)
        : formikValue,
    [formikValue, handelOptions],
  );
  const indexs = {
    0: 10,
    1: 9,
    2: 8,
    3: 7,
    4: 6,
    5: 5,
    6: 4,
    7: 3,
    8: 2,
    9: 1,
    10: 0,
  };
  const defaultStyle = {
    color: labelColor,
    fontSize: "18px",
    fontFamily: "Cairo",
    mb: 2,
  };
  const colourStyles = {
    control: (styles, { data, isDisabled, isFocused, isSelected }) => ({
      ...styles,
      backgroundColor: "#FBFBFB",
      padding: "8px",
      borderColor: isFocused ? "transparent" : "transparent",
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,

        color: "black",
        cursor: isDisabled ? "not-allowed" : "default",

        ":active": {
          ...styles[":active"],
        },
      };
    },
    multiValue: (styles, { data }) => {
      return {
        ...styles,
        backgroundColor: "white",
        border: "1px solid #E6E6E6",
        color: "#707070",
        fontSize: "18px",
      };
    },
    multiValueLabel: (styles, { data }) => ({
      ...styles,
      color: "#707070",
    }),
    multiValueRemove: (styles, { data }) => ({
      ...styles,
      color: "#ccc",
      ":hover": {
        backgroundColor: "#ccc",
        color: "white",
      },
    }),
  };

  const [searchFilterTimeout, setSearchFilterTimeout] = React.useState(null);

  const handleInputChange = (value, event) => {
    if (searchFilterTimeout) {
      clearTimeout(searchFilterTimeout);
    }
    const timeout = setTimeout(() => {
      if (event?.action === "input-change") {
        rest?.getList && rest?.getList({ keyword: value });
      }
    }, 500);
    setSearchFilterTimeout(timeout);
  };

  const handleMenuScrollToBottom = () => {
    if (options?.length < rest?.count) {
      rest?.getList({
        page_number: Math?.ceil(options?.length / 10 + 1),
      });
      return;
    }
  };
  return (
    <Stack
      w={"100%"}
      p="0"
      justifyContent="center"
      flexDirection={"column"}
      position="relative"
      zIndex={`${100 + indexs[index]} !important`}
      loadingMessage={() => <p>loading...</p>}
      onKeyDown={(e) => e.stopPropagation()}
    >
      <FormControl fullWidth>
        {label && (
          <Typography as="span" sx={defaultStyle}>
            {label}
          </Typography>
        )}

        <Select
          styles={colourStyles}
          id={name}
          name={name}
          options={handelOptions}
          onChange={(val) => {
            if (rest?.isMulti === false) {
              changeAction(val?.value ?? null);
            } else {
              changeAction(val);
            }
          }}
          value={valueData || value}
          placeholder={label}
          className="search-select"
          isMulti={rest?.isMulti !== undefined ? rest?.isMulti : true}
          {...rest}
          onMenuOpen={(_) => rest?.onOpen && rest?.onOpen()}
          onInputChange={
            rest?.applySearchFromRequest &&
            ((value, event) => handleInputChange(value, event))
          }
          onMenuScrollToBottom={handleMenuScrollToBottom}
        />
      </FormControl>
      <CFormErrors errorsMsg={errorsMsg} />
    </Stack>
  );
};

export default CMultiSelect;
